import {
    Alert, Checkbox as MuiCheckBox,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    SelectProps
} from "@mui/material";
import { useField } from "@unform/core";
import { useEffect, useMemo, useState } from "react";

type TOptions = {
    codigo: number | string;
    label: string;
}

type ICheckBoxProps = SelectProps & {
    isExternalLoading: boolean;
    name: string;
    label: string;
    items: TOptions[];
}

export const SelectComponent: React.FC<ICheckBoxProps> = ({ isExternalLoading = false, name, items, defaultValue, label, variant = "outlined", ...rest }) => {
    const { fieldName, registerField, error, clearError } = useField(name)

    const [value, setValue] = useState(defaultValue);  
    
    useEffect(() => {
        registerField({
            name: fieldName,
            getValue: () => value,
            setValue: (_, newSelectdId) => {
                setValue(newSelectdId === undefined ? 0 : newSelectdId);
                
            }
        })
    }, [registerField, fieldName, value])

    return (
        <FormControl fullWidth disabled={isExternalLoading}>
            <InputLabel id="demo-simple-select-label">{label}</InputLabel>
            <Select
                {...rest}
                variant={variant}
                placeholder={label}
                value={value}
                label={label}
                onChange={(e) => { setValue(e.target.value); rest.onChange?.(e, null); }}
                defaultValue={defaultValue || "" || 0}

            >
                <MenuItem value={0}>Selecione</MenuItem>
                {
                    items.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                }

            </Select>
        </FormControl >
    )
};